import React, { createContext, useState, useContext, useEffect } from 'react';

// Create the context
const DarkModeContext = createContext();

// Combined provider and logic to inject dark mode
export const DarkModeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        // Read the user's theme preference from localStorage on initial load
        const storedTheme = localStorage.getItem('theme');
   
        const isDark = storedTheme === 'dark';

        // Set the state based on the stored preference
        setIsDarkMode(isDark);

    }, []);

    useEffect(() => {
        // Apply or remove the dark-mode class based on isDarkMode state
        if (isDarkMode) {
            console.log("adding dark mode");
            document.body.classList.add('dark-mode');
            localStorage.setItem('theme', 'dark'); // Store the theme preference
        } else {
            console.log("removing dark mode");
            document.body.classList.remove('dark-mode');
            localStorage.setItem('theme', 'light'); // Store the theme preference
        }
    }, [isDarkMode]);

    return (
        <DarkModeContext.Provider value={{ isDarkMode, setIsDarkMode }}>
            {children}
        </DarkModeContext.Provider>
    );
};

// Custom hook to use the DarkModeContext
export const useDarkMode = () => useContext(DarkModeContext);
